import { Stack, Typography } from '@mui/material';
import { OtcOrderType } from '@protos/v2/otcQuote';
import { MIN_SIZE_VALUE } from '../constants';
import { TradingNumberInput } from './TradingNumberInput';

interface TradeSizeInputProps {
  sizeInputRef: React.RefObject<HTMLDivElement>;
  tradeSize: number;
  isTradeLimitBreached: boolean;
  showUserInputError: boolean;
  onTradeSizeChange: (event: any, value: number | undefined) => void;
  rawTradingAmount?: string;
  isBelowMinTrade: boolean;
  minTrade: number;
  handleTradeSizeUpdating: (isUpdating: boolean) => void;
  orderType?: OtcOrderType;
}

export const TradeSizeInput = ({
  sizeInputRef,
  tradeSize,
  isTradeLimitBreached,
  showUserInputError,
  rawTradingAmount,
  onTradeSizeChange,
  isBelowMinTrade,
  minTrade,
  handleTradeSizeUpdating,
  orderType,
}: TradeSizeInputProps) => {
  return (
    <Stack alignItems="center" justifyContent="end" position="relative" sx={{ marginTop: orderType === OtcOrderType.limit ? '0.5em' : '0' }}>
      <TradingNumberInput
        ref={sizeInputRef}
        label={`RFQ Lots ${rawTradingAmount ? `(${rawTradingAmount})` : ''}`}
        value={tradeSize}
        min={MIN_SIZE_VALUE}
        onChange={onTradeSizeChange}
        tabIndex={1}
        error={showUserInputError}
        allowClearable
        sizeSmall
        handleTradeSizeUpdating={handleTradeSizeUpdating}
      />
      {isBelowMinTrade && (
        <Typography fontSize={9} color="error" tabIndex={-1}>
          Trade size is below minimum limit ({minTrade})
        </Typography>
      )}
      {isTradeLimitBreached && (
        <Typography fontSize={9} color="error" tabIndex={-1}>
          Trade size exceeds trading limit
        </Typography>
      )}
    </Stack>
  );
};
